import api from './axiosConfig';
import { TEAM_ENDPOINT } from './apiEndpoints';
import { getItem } from "../utils/localStorageUtil";
import { logError } from './errorLogService';
import { notifyCacheUsed } from '../hooks/useOfflineStatus';

const isZho = getItem('lang') == 'zho'
const mockTeamData =
    [
        {
            id: 2,
            name: "Florencia Astoul Bonorino",
            role: isZho ? '拉美地区品牌和传播主管' : "LATAM Regional Branding & Communication Lead",
            image_src: "/assets/images/team/Flor_Astoul_Bonorino.webp",
        },
        {
            id: 3,
            name: "Murat Mert",
            role: isZho ? 'Rainbow Bio 全球负责人兼土耳其总经理' : "Global Head for Rainbow Bio & Turkey General Manager",
            image_src: "/assets/images/team/Murat_Mert.webp",
        },
        {
            id: 9,
            name: "Alejandro Crespo",
            role: isZho ? '全球业务总经理' : "Global Commercial Head",
            image_src: "/assets/images/team/Alejandro_Crespo.webp",
        },
        {
            id: 10,
            name: "Adrian Liew",
            role: isZho ? '马来西亚国家经理' : "Country Head for Malaysia",
            image_src: "/assets/images/team/Adrian_Liew.webp",
        },
        {
            id: 12,
            name: "Fabricio Ruzafa",
            role: isZho ? '产品经理' : "Market Access Manager Brazil",
            image_src: "/assets/images/team/Fabricio_Ruzafa.webp",
        },
        {
            id: 1,
            name: "Jose Miquelerena",
            role: isZho ? 'SouthernCone 市场开发经理' : "Portfolio Manager for SouthernCone",
            image_src: "/assets/images/team/Jose_De_Miquelerena.webp",
        },
        {
            id: 18,
            name: "Luiz Henrique Marcandalli",
            role: isZho ? '巴西营销经理' : "National Marketing Manager",
            image_src: "/assets/images/team/Luis Mercandalli.webp",
        },
        {
            id: 13,
            name: "Marina Martí Sarabia",
            role: isZho ? '西班牙 Sarabia 总经理' : "General Manager at Sarabia, Spain",
            image_src: "/assets/images/team/Marina_Marti.webp",
        },
        {
            id: 14,
            name: "Ozan Özgünay",
            role: isZho ? 'Rainbow Bio 全球营销与战略主管' : "Global Marketing & Strategy Head for Rainbow Bio",
            image_src: "/assets/images/team/Ozan.webp",
        },
        {
            id: 4,
            name: "Benjamin Robles",
            role: isZho ? '墨西哥总经理' : "Mexico General Manager",
            image_src: "/assets/images/team/Benjamin_Robles.webp",
        },
        {
            id: 5,
            name: "Emmanuel Sanchez",
            role: isZho ? '墨西哥和安第斯国家监管事务负责人' : "Regulatory Affairs for Mexico and Andean Countries Head",
            image_src: "/assets/images/team/Emmanuel_Sanchez.webp",
        },
        {
            id: 6,
            name: "Tom Lyons",
            role: isZho ? '北美大区总经理' : "North America Regional Head",
            image_src: "/assets/images/team/Tom_Lyons.webp",
        },
        {
            id: 7,
            name: "Jackson Han",
            role: isZho ? 'Southern Cone 区域经理' : "Southern Cone Area Head",
            image_src: "/assets/images/team/Jackson_Ha.webp",
        },
        {
            id: 15,
            name: "Lim Kiatcong",
            role: isZho ? '马来西亚市场经理' : "Marketing Manager for Malaysia",
            image_src: "/assets/images/team/Lim_Kiatcong.webp",
        },
        {
            id: 8,
            name: "Daisy Feng",
            role: isZho ? '全球战略和业务发展总监' : "Global Strategy & Business Development Head",
            image_src: "/assets/images/team/Daisy_Feng.webp",
        },
        {
            id: 16,
            name: "Carlos Danilowicz",
            role: isZho ? '阿根廷总经理' : "Argentina General Manager",
            image_src: "/assets/images/team/Carlos_Danilowicz.webp",
        },
        {
            id: 17,
            name: "May Matheu",
            role: isZho ? '全球品牌与宣传总监' : "Global Branding and Communication Lead",
            image_src: "/assets/images/team/May_Matheu.webp",
        },

    ];

export const fetchTeam = async (retryCount = 2) => {
    // return mockTeamData;

    try {
        // throw new Error('Forced error for testing error logging system');
        const response = await api.get(TEAM_ENDPOINT(), {
            timeout: 30000, // 30 seconds timeout for this specific request
        });
        return response.data;
    } catch (error) {
        const isTimeout = error.code === 'ECONNABORTED' || error.message?.includes('timeout');
        const isNetworkError = !error.response && error.request;
        
        // Retry logic for timeouts and network errors
        if ((isTimeout || isNetworkError) && retryCount > 0) {
            console.warn(`Team data fetch ${isTimeout ? 'timeout' : 'network error'}, retrying... (${retryCount} attempts left)`);
            await new Promise(resolve => setTimeout(resolve, 1000)); // Wait 1 second before retry
            return fetchTeam(retryCount - 1);
        }

        console.error("Error fetching team data", error);

        // Log error with context for debugging geographical issues
        await logError('team_data_fetch', error, {
            endpoint: TEAM_ENDPOINT(),
            response_status: error.response?.status,
            response_data: error.response?.data,
        });

        // Notify UI that we're using cached/mock data
        //notifyCacheUsed();

        return mockTeamData;
    }
};
